import { OnInit } from '@angular/core';
var StarsComponent = /** @class */ (function () {
    function StarsComponent() {
        this.color = 'rgb(255, 178, 0)';
        this.stars = [
            'star_border',
            'star_border',
            'star_border',
            'star_border',
            'star_border'
        ];
    }
    StarsComponent.prototype.ngOnInit = function () {
        for (var i = 0; i < this.rating; i++) {
            this.stars[i] = 'star';
        }
        if (!Number.isInteger(this.rating)) {
            var decimalNumber = this.rating % 1;
            if (decimalNumber > 0.25) {
                this.stars[this.stars.lastIndexOf('star')] = 'star_half';
            }
            else {
                this.stars[this.stars.lastIndexOf('star')] = 'star_border';
            }
        }
    };
    return StarsComponent;
}());
export { StarsComponent };
